module.exports = __webpack_public_path__ + "top_page/top-industry-office-7902c714d44f7a85e63e372f010dd529.svg";